import { Link } from 'react-router-dom';
import Icon from './Icons';
import Revelar from './Revelar';
import servicos from '../data/servicos';
import './Areas.css';

export default function Areas() {
  return (
    <section className="secao" id="areas">
      <div className="container">
        <div className="cabecalho-secao cabecalho-secao--centro">
          <span className="rotulo">Áreas de Atuação</span>
          <h2 className="titulo-secao">Onde a defesa pode atuar</h2>
          <p className="subtitulo-secao">
            Atuação em investigações, ações penais e execução da pena, para
            clientes de qualquer estado. Não encontrou o seu caso na lista?
            Entre em contato: a análise inicial orienta o caminho adequado.
          </p>
        </div>

        <ul className="areas__grade">
          {servicos.map((servico, indice) => (
            <Revelar
              as="li"
              key={servico.id}
              atraso={(indice % 3) * 90}
              className="area"
            >
              <span className="area__icone" aria-hidden="true">
                <Icon name={servico.icone} size={26} />
              </span>

              <h3>
                <Link to={`/${servico.slug}`}>{servico.titulo}</Link>
              </h3>
              <p>{servico.resumo}</p>

              <ul className="area__itens">
                {servico.itens.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>

              <Link className="area__link" to={`/${servico.slug}`}>
                Ver como a defesa atua
                <Icon name="seta" size={17} />
              </Link>
            </Revelar>
          ))}
        </ul>

        <p className="areas__aviso">
          As informações desta página têm caráter meramente informativo e não
          constituem consulta jurídica. Cada situação exige análise individual
          dos fatos e dos documentos.
        </p>
      </div>
    </section>
  );
}
